import * as React from 'react';
import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../common/state';
import { EContractType } from '../../../../json_query';
import { getTermsValue } from '../../../../json_query/reducers/helpers';
import { FDealType } from '../../../../utils/category';
import { pushTermsValue, removeTermsValue } from '../../../state/advanced/terms';
import { Row } from '../markup';
import { ButtonCheckboxList } from './button_checkbox_list';

export const ContractTypesForSale = [
  { title: 'Продажа объекта', value: EContractType.ObjSale },
  { title: 'Переуступка прав аренды', value: EContractType.PermTransfer },
];

export const ContractTypesForRent = [
  { title: 'Прямая аренда', value: EContractType.DirectRent },
  { title: 'Субаренда', value: EContractType.SubRent },
];

export interface IContractProps {
  dealType: FDealType;
  selected: EContractType[];
  select(value: EContractType): void;
  deselect(value: EContractType): void;
}

class Contract extends React.PureComponent<IContractProps> {
  public render() {
    const { dealType, deselect, selected, select } = this.props;

    return (
      <Row title="Тип договора">
        <ButtonCheckboxList
          deselect={deselect}
          list={dealType === FDealType.Sale ? ContractTypesForSale : ContractTypesForRent}
          select={select}
          selected={selected}
        />
      </Row>
    );
  }
}

// tslint:disable-next-line:no-default-export
export default connect<
  {
    selected: EContractType[];
  },
  {
    select(value: EContractType): void;
    deselect(value: EContractType): void;
  },
  {
    dealType: FDealType;
  }
>(
  (state: IAppState) => ({
    selected: getTermsValue('contract')(state.filters.jsonQuery),
  }),
  (dispatch: Dispatch) => ({
    select: (value: EContractType) => {
      dispatch(pushTermsValue('contract')(value));
    },
    deselect: (value: EContractType) => {
      dispatch(removeTermsValue('contract')(value));
    },
  }),
)(Contract);
